import { State } from '../ducks';
import getCurrentUserSelector from './getCurrentUserSelector';

const getIsSuperAdminSelector = (state: State) => {
  const currentUser = getCurrentUserSelector(state);
  return currentUser?.role === 'SUPER_ADMIN';
};

export default getIsSuperAdminSelector;
